import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { ShareToBrainSyncDemo } from './OnboardingOverlay';

// ShareDemoRefresherModal - opened from the user dropdown so existing
// users (who blew past or never saw the onboarding) can still discover
// the OS-share-sheet workflow that everything else in BrainSync's
// daily-use loop hinges on. Reuses the same `ShareToBrainSyncDemo`
// animation that ships in the first-run onboarding so there's a
// single source of truth for the mockup styling.
//
// Visual treatment matches the onboarding slide #2: dark forest
// gradient, grain texture, vignette, emerald accent - feels like a
// piece of the product, not a generic shadcn dialog.
export const ShareDemoRefresherModal = ({ open, onOpenChange }) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent
            // Mirror the geometry tricks from UsernameSettingsModal -
            // every grid child gets `min-w-0` so the phone-mockup can
            // never blow the modal wider than the viewport on mobile.
            // `p-0` lets the gradient header bleed edge-to-edge for a
            // premium card look.
            className="max-w-[calc(100vw-2rem)] sm:max-w-md min-w-0 max-h-[90vh] overflow-y-auto overflow-x-hidden p-0 rounded-3xl ring-1 ring-black/5 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.4)]"
            data-testid="share-demo-refresher-modal"
        >
            {/* Hero - dark forest gradient with grain + vignette,
                matches onboarding slide #2 exactly. */}
            <div className="relative bg-gradient-to-br from-zinc-900 via-emerald-950 to-zinc-900 px-6 pt-8 pb-8 flex flex-col items-center text-white overflow-hidden min-w-0">
                <div
                    className="pointer-events-none absolute inset-0 opacity-[0.07] mix-blend-overlay"
                    style={{
                        backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'3\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")',
                    }}
                />
                <div className="pointer-events-none absolute inset-0 shadow-[inset_0_0_120px_rgba(0,0,0,0.4)]" />

                <div className="relative z-10 w-full flex flex-col items-center min-w-0">
                    <ShareToBrainSyncDemo />
                    <DialogHeader className="mt-2 min-w-0">
                        <DialogTitle className="font-heading text-2xl font-bold text-center text-white tracking-tight" style={{ lineHeight: '1.15' }}>
                            Share from any app
                        </DialogTitle>
                        <DialogDescription className="mt-1.5 text-sm text-emerald-200/90 font-medium tracking-wide text-center">
                            The fastest way to save
                        </DialogDescription>
                    </DialogHeader>
                </div>
            </div>
            <div className="px-7 py-6 min-w-0">
                <p className="text-[13px] text-zinc-600 text-center leading-relaxed">
                    Found a great post on TikTok, Instagram, YouTube, or X?
                    Tap the share button, pick BrainSync, and it's saved -
                    title, transcript, summary, and tags handled automatically.
                </p>
            </div>
        </DialogContent>
    </Dialog>
);

export default ShareDemoRefresherModal;
